exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdl-card__title.mdl-card--expand{display:flex;flex-direction:column}.mdl-card__title.mdl-card--expand .skill-level{display:flex;flex-direction:column;justify-content:center;align-items:center}[data-component=home-portfolio-card],[data-component=portfolio-card]{margin:0 10px 10px 0;z-index:0!important}[data-component=home-portfolio-card]{width:500px!important}[data-component=home-portfolio-card]>div{justify-content:center!important}[data-component=home-portfolio-card] button>span{font-size:15px}[data-component=card-title]{color:#fff!important;height:176px;background:url(" + require("../../assets/welcome_card.jpg") + ") 50%/cover}[data-component=card-bottom]>a{color:transparent}[data-component=card-bottom]>button{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./app/components/cards/style.scss
// module id = 578
// module chunks = 0